export const HEADER_TEXT = {
	userProfile: {
		profile: 'Profile',
		logoutButton: 'Log out',
		loginButton: 'Log in',
	},
};
